import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronDown, Menu, X, Home } from "lucide-react";
import { navMenu, SRETRADE_LOGIN, SRETRADE_REGISTER, ACAR_LOGO_URL } from "../mock";

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openMobileSub, setOpenMobileSub] = useState(null);
  const location = useLocation();

  return (
    <header className="sticky top-0 z-50 bg-white">
      {/* Main nav */}
      <div className="bg-white border-b border-slate-100 shadow-[0_2px_8px_-4px_rgba(0,0,0,0.08)]">
        <div className="max-w-[1280px] mx-auto px-4 h-[78px] flex items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <AcarLogo />
          </Link>

          {/* Desktop nav */}
          <nav className="hidden xl:flex items-center gap-0.5 flex-1 justify-end">
            <Link
              to="/"
              className={`nav-item relative px-2.5 py-2 text-[13px] font-medium text-slate-700 hover:text-[#1c4d9c] transition flex items-center ${
                location.pathname === "/" ? "text-[#1c4d9c]" : ""
              }`}
            >
              <Home className="w-[16px] h-[16px]" />
              {location.pathname === "/" && (
                <span className="absolute -bottom-[2px] left-2.5 right-2.5 h-[3px] bg-[#1c4d9c] rounded-full" />
              )}
            </Link>
            {navMenu.map((item) => {
              const active = location.pathname.startsWith(item.slug);
              return (
                <div key={item.slug} className="nav-item relative">
                  <Link
                    to={item.slug}
                    className={`px-2.5 py-2 text-[13px] font-medium hover:text-[#1c4d9c] transition flex items-center gap-1 ${
                      active ? "text-[#1c4d9c]" : "text-slate-700"
                    }`}
                  >
                    {item.label}
                    {item.children && (
                      <ChevronDown className="w-3 h-3 opacity-70" />
                    )}
                  </Link>
                  {active && (
                    <span className="absolute -bottom-[2px] left-2.5 right-2.5 h-[3px] bg-[#1c4d9c] rounded-full" />
                  )}
                  {item.children && (
                    <div className="mega-dropdown py-2">
                      {item.children.map((c) => (
                        <Link
                          key={c.slug}
                          to={c.slug}
                          className="block px-4 py-2 text-[12.5px] text-slate-700 hover:bg-[#1c4d9c]/5 hover:text-[#1c4d9c] transition border-l-2 border-transparent hover:border-[#1c4d9c]"
                        >
                          {c.label}
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
            <a
              href={SRETRADE_REGISTER}
              target="_blank"
              rel="noreferrer"
              className="ml-2 px-3.5 py-1.5 rounded-md bg-[#e23a3a] hover:bg-[#c52d2d] text-white font-semibold text-[12px] transition shadow-sm"
            >
              Hesap Aç
            </a>
            <a
              href={SRETRADE_LOGIN}
              target="_blank"
              rel="noreferrer"
              className="ml-1.5 px-3.5 py-1.5 rounded-md bg-[#2b2b35] hover:bg-black text-white font-semibold text-[12px] transition flex items-center gap-1"
            >
              Online İşleme Giriş
              <ChevronDown className="w-3 h-3" />
            </a>
          </nav>

          {/* Mobile menu toggle */}
          <button
            className="xl:hidden p-2 text-slate-700"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Menu"
          >
            {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile nav */}
        {mobileOpen && (
          <div className="xl:hidden border-t border-slate-100 max-h-[80vh] overflow-y-auto">
            <Link
              to="/"
              onClick={() => setMobileOpen(false)}
              className="flex items-center gap-2 px-5 py-3 text-slate-700 border-b border-slate-100"
            >
              <Home className="w-4 h-4" /> Anasayfa
            </Link>
            {navMenu.map((item) => (
              <div key={item.slug} className="border-b border-slate-100">
                <button
                  className="w-full px-5 py-3 flex items-center justify-between text-slate-700 font-medium text-sm"
                  onClick={() =>
                    setOpenMobileSub(openMobileSub === item.slug ? null : item.slug)
                  }
                >
                  <span>{item.label}</span>
                  {item.children && (
                    <ChevronDown
                      className={`w-4 h-4 transition-transform ${
                        openMobileSub === item.slug ? "rotate-180" : ""
                      }`}
                    />
                  )}
                </button>
                {item.children && openMobileSub === item.slug && (
                  <div className="bg-slate-50">
                    {item.children.map((c) => (
                      <Link
                        key={c.slug}
                        to={c.slug}
                        onClick={() => setMobileOpen(false)}
                        className="block px-8 py-2.5 text-sm text-slate-600 hover:text-[#1c4d9c]"
                      >
                        {c.label}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            ))}
            <div className="p-4 flex flex-col gap-2">
              <a
                href={SRETRADE_REGISTER}
                target="_blank"
                rel="noreferrer"
                className="w-full px-4 py-2.5 rounded-md bg-[#e23a3a] text-white text-center font-semibold text-sm"
              >
                Hesap Aç
              </a>
              <a
                href={SRETRADE_LOGIN}
                target="_blank"
                rel="noreferrer"
                className="w-full px-4 py-2.5 rounded-md bg-[#2b2b35] text-white text-center font-semibold text-sm"
              >
                Online İşleme Giriş
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export const AcarLogo = ({ size = "normal" }) => {
  const h = size === "small" ? 44 : 56;
  return (
    <div className="flex items-center">
      <img
        src={ACAR_LOGO_URL}
        alt="Acar Online Şube"
        style={{ height: h, width: "auto" }}
        className="object-contain"
      />
    </div>
  );
};

export default Header;
